

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CURRENCY_FORMAT } from '@/helpers/currency';
import machineryRentalsRepository from '@/modules/machinery/services/machineryRentalsRepository';
import notificationService from '@/services/notificationService';
import { MachineryRentalInvoicingMode, MachineryRentalFrequency } from '@/modules/machinery/enums';
import Popup from '@/components/default/Popup.vue';
import {
  DxForm,
  DxSimpleItem,
  DxRequiredRule,
  DxGroupItem,
  DxLabel,
} from 'devextreme-vue/form';

import dxCustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import customersRepository from '@/services/customers/customersRepository';
import projectsRepository from '@/services/projectsRepository';

@Component({
  components: {
    Popup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
  },
})
export default class MachineryRentalEditDialog extends Vue {
    @Prop({ required: true })
    private rental!: IMachineryRentalDto;

    private model: IMachineryRentalUpdateCommand = {
        id: '',
        machineryId: '',
        projectId: '',
        customerId: '',
        contactId: '',
        begin: '',
        lastInvoicedDate: '',
        end: '',
        unitPrice: 0,
        taxrate: 21,
        invoicingMode: 0,
        frequency: 0,
        rentalMode: 0,
        prepayment: false,
    };

    private contractTemplates: IMachineryTemplate[] = [];
    private showValue: boolean = false;
    private saving: boolean = false;
    private contractGenerationModel: IMachineryGenerateContractCommand = {
        id: '',
        template: '',
    };

    public show() {
        this.showValue = true;
    }

    public hide() {
        this.showValue = false;
    }

    private async created() {
        this.model = Object.assign(this.model, this.rental);
    }

    private async save() {
        try {
            const validationResult = (this.$refs.form as any).instance.validate();
            if (validationResult.isValid) {
                this.saving = true;
                // Create
                await machineryRentalsRepository.update(this.model);
                notificationService.saved();
                this.hide();
                this.$emit('updated');
            } else {
                notificationService.invalidForm();
            }
        } catch (err) {
        notificationService.showAxiosError(err);
        } finally {
        this.saving = false;
        }
    }

    get customersOptions() {
        const self = this;
        return {
            dataSource: new DataSource({
                store: new dxCustomStore({
                load: async (loadOptions: any) => {
                    const result = await customersRepository.get(loadOptions);
                    return {
                    data: result.data,
                    };
                },
                byKey: async (val: any) => {
                    if (self.model === null) {
                        return {};
                    }

                    return {
                        id: self.model.customerId,
                        displayName: self.rental.customerName,
                    };
                },
                }),
                paginate: true,
            }),
            valueExpr: 'id',
            displayExpr: 'displayName',
            searchEnabled: true,
        };
    }

    get projectsOptions() {
        const self = this;
        return {
            dataSource: new DataSource({
                store: new dxCustomStore({
                    key: 'id',
                    load: async (loadOptions) => {
                        if (Array.isArray(loadOptions.filter) &&
                            loadOptions.filter.length > 1 && loadOptions.filter[0] === 'id') {

                            return {
                                data: [],
                                totalCount: 0,
                            };
                        }

                        if (loadOptions.searchExpr && loadOptions.searchValue && loadOptions.searchOperation) {
                            loadOptions.filter =
                                [loadOptions.searchExpr, loadOptions.searchOperation, loadOptions.searchValue];
                        }

                        const result = await projectsRepository.lookup(loadOptions);

                        return {
                            data: result.data.data,
                            totalCount: result.data.totalCount,
                        };
                    },
                    byKey: async (val: any) => {
                        return projectsRepository.getSingle(val).then((result: any) => {
                            return result.data;
                        });
                    },
                }),
                paginate: true,
            }),
            valueExpr: 'id',
            displayExpr: 'name',
            searchExpr: 'name',
            searchEnabled: true,
            showClearButton: true,
        };
    }

    get fields() {
        return [
        {
            itemType: 'simple',
            dataField: 'customerId',
            editorOptions: this.customersOptions,
            editorType: 'dxSelectBox',
            label: {
            text: 'Klant',
            },
            validationRules: [
            {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'projectId',
            editorOptions: this.projectsOptions,
            editorType: 'dxSelectBox',
            label: {
            text: 'project',
            },
        },
        {
            itemType: 'simple',
            dataField: 'begin',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
            text: 'Begin',
            },
            validationRules: [
            {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'end',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
            text: 'Einde',
            },
        },
        {
            itemType: 'simple',
            dataField: 'lastInvoicedDate',
            editorOptions: { width: '100%', useMaskBehavior: true },
            editorType: 'dxDateBox',
            label: {
            text: 'Laatste factuur datum',
            },
        },
        {
            itemType: 'simple',
            dataField: 'invoicingMode',
            editorOptions: {
            items: [
                { value: MachineryRentalInvoicingMode.Manual, text: 'Manueel' },
                { value: MachineryRentalInvoicingMode.Periodic, text: 'Periodiek' },
            ],
            valueExpr: 'value',
            displayExpr: 'text',
            searchEnabled: true,
            },
            editorType: 'dxSelectBox',
            label: {
            text: 'Facturatiemodus',
            },
            validationRules: [
            {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'frequency',
            editorOptions: {
            items: [
                { value: MachineryRentalFrequency.Daily, text: 'Dagelijks' },
                { value: MachineryRentalFrequency.Weekly, text: 'Wekelijks' },
                { value: MachineryRentalFrequency.Monthly, text: 'Maandelijks' },
            ],
            valueExpr: 'value',
            displayExpr: 'text',
            searchEnabled: true,
            },
            editorType: 'dxSelectBox',
            label: {
            text: 'Frequentie',
            },
            validationRules: [
            {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'rentalMode',
            editorOptions: {
            items: [
                { value: 0, text: 'Huren' },
                { value: 1, text: 'Huurkoop' },
            ],
            valueExpr: 'value',
            displayExpr: 'text',
            searchEnabled: true,
            },
            editorType: 'dxSelectBox',
            label: {
            text: 'Soort',
            },
            validationRules: [
            {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'unitPrice',
            editorType: 'dxNumberBox',
            editorOptions: {
                format: CURRENCY_FORMAT,
            },
            label: {
            text: 'Prijs',
            },
            validationRules: [
            {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'taxrate',
            editorType: 'dxNumberBox',
            label: {
                text: 'BTW %',
            },
            validationRules: [
                {type: 'required', message: 'Veld is verplicht'},
            ],
        },
        {
            itemType: 'simple',
            dataField: 'prepayment',
            editorType: 'dxCheckBox',
            label: {
                text: 'Voorafbetaling',
            },
        },
        ];
    }

    @Watch('rental', { deep: true })
    private onRentalChanged() {
        this.model = Object.assign(this.model, this.rental);
    }
}
